import { Component, input, signal, SimpleChanges } from '@angular/core';
import { DropdownControl } from '../../../controls/setup-wizard/dropdown-control/dropdown-control';
import { FormGroup } from '@angular/forms';
import { RubricService } from '../../../../services/rubric.service';

@Component({
	selector: 'app-rubric-level-dropdown-field',
	imports: [DropdownControl],
	standalone: true,
	templateUrl: './rubric-level-dropdown-field.html',
	styleUrl: './rubric-level-dropdown-field.scss',
})
export class RubricLevelDropdownField {
	rubricCode = input.required<string>();
	label = input.required<string>();
	controlName = input.required<string>();
	placeholder = input<string>('');
	required = input<boolean>(true);
	formGroup = input.required<FormGroup>();
	options = signal<{ value: string; label: string }[]>([]);

	constructor(private rubricService: RubricService) {}

	ngOnChanges(changes: SimpleChanges) {
		if (changes['rubricCode'] && this.rubricCode()) {
			this.rubricService.getRubricLevels$(this.rubricCode()).then(levels => {
				this.options.set(
					levels.map(level => ({ value: level.level.toString(), label: level.level.toString() }))
				);
			});
		}
	}
}
